import axios from "axios";

const header = {
  headers: {
    "api-security-key": "89343EA2-368C-4ABB-90DE-039BE336D2DD",
  },
};

export const Get = async (url) => {
  return await axios
    .get(`${process.env.VUE_APP_API_URL}/${url}`, header)
    .then((res) => {
      return res;
    });
};

export const Post = async (url, payload) => {
  return await axios
    .post(`${process.env.VUE_APP_API_URL}/${url}`, payload, header)
    .then((res) => {
      return res;
    });
};

export const PostFormData = async (url, payload) => {
  var formHeaders = {
    headers: {
      "api-security-key": "89343EA2-368C-4ABB-90DE-039BE336D2DD",
      // "Content-Type": "multipart/form-data",
    },
  };

  return await axios
    .post(`${process.env.VUE_APP_API_URL}/${url}`, payload, formHeaders)
    .then((res) => {
      return res;
    });
};
export const Delete = async (url) => {
  return await axios
    .delete(`${process.env.VUE_APP_API_URL}/${url}`, header)
    .then((res) => {
      return res;
    });
};

export const Put = async (url, payload) => {
  return await axios
    .put(`${process.env.VUE_APP_API_URL}/${url}`, payload, header)
    .then((res) => {
      return res;
    });
};

export const PutFormData = async (url, payload) => {
  var formHeaders = {
    headers: {
      "api-security-key": "89343EA2-368C-4ABB-90DE-039BE336D2DD",
      // "Content-Type": "multipart/form-data",
    },
  };

  return await axios
    .put(`${process.env.VUE_APP_API_URL}/${url}`, payload, formHeaders)
    .then((res) => {
      return res;
    });
};
